import {i18n} from '@yourcoach/i18n';

import Icon from '../../../assets/icons/empty-state/talk_now.svg';
import {alert} from '../../../components/alert';
import {logger} from '../../../utils/logger';

export const showBusyAlert = () => {
  const onClose = () => {
    logger.event('busy_alert_close');
  };

  logger.event('busy_alert_view');

  alert.show({
    buttons: [
      {
        label: i18n.t('shared:ok'),
        onClick: onClose,
        scheme: 'primary',
      },
    ],
    icon: Icon,
    iconColor: 'icon.primary',
    iconSize: 160,
    isDismissible: true,
    message: i18n.t('shared:coaching_experts_busy_message'),
    onDismiss: onClose,
    title: i18n.t('shared:coaching_experts_busy'),
  });
};
